/* CUSTOM: Charm engraving add-on. Pairs with snippets/charm-engraving.liquid. */

console.log('[charm] script v3 loaded');

const CHARM_SHAPES = {
  rect: {
    svg: '<rect x="9" y="43" width="102" height="34" rx="8"/>',
    size: 12,
    two: [56, 71],
    one: 65,
  },
  heart: {
    svg: '<path d="M60 106 C60 106 12 68 12 42 C12 26 24 15 37 15 C48 15 57 22 60 31 C63 22 72 15 83 15 C96 15 108 26 108 42 C108 68 60 106 60 106 Z"/>',
    size: 14,
    two: [48, 66],
    one: 56,
  },
  circle: {
    svg: '<circle cx="60" cy="60" r="46"/>',
    size: 14,
    two: [54, 73],
    one: 66,
  },
};

const CHARM_ALLOWED = /^[A-Za-z0-9 .,'\u2019&/\-]*$/;

class CharmEngraving extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-charm-toggle]');
    this.details = this.querySelector('[data-charm-details]');
    this.shapes = Array.from(this.querySelectorAll('[data-charm-shape]'));
    this.error = this.querySelector('[data-charm-error]');

    if (!this.toggle || !this.details || !this.shapes.length) {
      console.warn('[charm] markup incomplete, aborting');
      return;
    }

    this.field = {};
    this.count = {};
    this.preview = {};
    ['front-1', 'front-2', 'back-1', 'back-2'].forEach((key) => {
      this.field[key] = this.querySelector('[data-charm-line="' + key + '"]');
      this.count[key] = this.querySelector('[data-charm-count="' + key + '"]');
      this.preview[key] = this.querySelector('[data-charm-preview="' + key + '"]');
    });

    this.shapeFront = this.querySelector('[data-charm-preview-shape="front"]');
    this.shapeBack = this.querySelector('[data-charm-preview-shape="back"]');
    this.frontCaption = this.querySelector('[data-charm-caption]');
    this.backPreview = this.querySelector('[data-charm-back-preview]');

    this.back = this.querySelector('[data-charm-back]');
    this.backOptions = this.querySelector('[data-charm-back-options]');
    this.backFields = this.querySelector('[data-charm-back-fields]');
    this.backModes = Array.from(this.querySelectorAll('[data-charm-backmode]'));

    this.form =
      document.getElementById('product-form-' + this.dataset.sectionId) ||
      document.querySelector('form[data-type="add-to-cart-form"]');

    if (this.form) {
      this.submitButton = this.form.querySelector('[type="submit"]');
      this.buttonLabel = this.submitButton ? this.submitButton.querySelector('span') : null;
      this.defaultLabel = this.buttonLabel ? this.buttonLabel.textContent : '';
      this.errorWrapper = this.form.querySelector('.product-form__error-message-wrapper');
      this.onSubmit = this.onSubmit.bind(this);
      document.addEventListener('submit', this.onSubmit, true);
    } else {
      console.warn('[charm] product form not found, cart add disabled');
    }

    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    this.toggle.addEventListener('change', () => this.onToggle());
    this.shapes.forEach((input) => input.addEventListener('change', () => this.onShape()));
    Object.keys(this.field).forEach((key) => {
      if (this.field[key]) this.field[key].addEventListener('input', () => this.paint());
    });
    if (this.back) this.back.addEventListener('change', () => this.onBack());
    this.backModes.forEach((input) => input.addEventListener('change', () => this.onBack()));

    this.onShape();
    this.onBack();
    this.onToggle();
  }

  disconnectedCallback() {
    if (this.onSubmit) document.removeEventListener('submit', this.onSubmit, true);
  }

  get shape() {
    return this.shapes.find((input) => input.checked) || this.shapes[0];
  }

  get bothSides() {
    return !!(this.back && this.back.checked && this.shape.dataset.both);
  }

  get sameText() {
    const mode = this.backModes.find((input) => input.checked);
    return !!mode && mode.value === 'same';
  }

  get price() {
    const shape = this.shape;
    return this.bothSides ? shape.dataset.priceBoth : shape.dataset.priceOne;
  }

  onToggle() {
    const on = this.toggle.checked;
    this.details.hidden = !on;
    this.updateLabel();
    if (!on) this.clearError();
  }

  updateLabel() {
    if (!this.buttonLabel) return;
    if (!this.toggle.checked || !this.price) {
      this.buttonLabel.textContent = this.defaultLabel;
      return;
    }
    const template = this.dataset.labelTemplate || 'Add to cart (+%price%)';
    this.buttonLabel.textContent = template.replace('%price%', this.price);
  }

  onBack() {
    const on = this.bothSides;
    if (this.backOptions) this.backOptions.hidden = !on;
    if (this.backPreview) this.backPreview.hidden = !on;
    if (this.frontCaption) this.frontCaption.hidden = !on;
    if (this.backFields) this.backFields.hidden = !on || this.sameText;
    this.updateLabel();
    this.paint();
  }

  onShape() {
    const shape = this.shape;
    if (!shape) return;
    const limits = { '1': parseInt(shape.dataset.l1, 10), '2': parseInt(shape.dataset.l2, 10) };
    Object.keys(this.field).forEach((key) => {
      const input = this.field[key];
      if (!input) return;
      const limit = limits[key.split('-')[1]];
      input.maxLength = limit;
      if (input.value.length > limit) input.value = input.value.slice(0, limit);
    });

    const geometry = CHARM_SHAPES[shape.dataset.charmShape];
    if (this.shapeFront) this.shapeFront.innerHTML = geometry.svg;
    if (this.shapeBack) this.shapeBack.innerHTML = geometry.svg;
    Object.keys(this.preview).forEach((key) => {
      if (this.preview[key]) this.preview[key].setAttribute('font-size', geometry.size);
    });

    if (this.back && !shape.dataset.both) {
      this.back.checked = false;
      this.back.disabled = true;
    } else if (this.back) {
      this.back.disabled = false;
    }

    this.onBack();
  }

  backValues() {
    if (this.sameText) {
      return [this.value('front-1'), this.value('front-2')];
    }
    return [this.value('back-1'), this.value('back-2')];
  }

  value(key) {
    return this.field[key] ? this.field[key].value : '';
  }

  paintFace(prefix, geometry, values) {
    const twoLines = values[1].trim().length > 0;
    const first = this.preview[prefix + '-1'];
    const second = this.preview[prefix + '-2'];
    if (!first || !second) return;
    first.setAttribute('y', twoLines ? geometry.two[0] : geometry.one);
    second.setAttribute('y', geometry.two[1]);
    first.textContent = values[0];
    second.textContent = twoLines ? values[1] : '';
  }

  paint() {
    const geometry = CHARM_SHAPES[this.shape.dataset.charmShape];
    this.paintFace('front', geometry, [this.value('front-1'), this.value('front-2')]);
    if (this.bothSides) this.paintFace('back', geometry, this.backValues());

    Object.keys(this.field).forEach((key) => {
      const input = this.field[key];
      if (!input || !this.count[key]) return;
      this.count[key].textContent = input.value.length + '/' + input.maxLength;
      this.count[key].dataset.full = input.value.length >= input.maxLength ? 'true' : 'false';
    });

    this.clearError();
  }

  clearError() {
    if (!this.error) return;
    this.error.hidden = true;
    this.error.textContent = '';
  }

  showError(message, field) {
    if (!this.error) return;
    this.error.textContent = message;
    this.error.hidden = false;
    if (field) field.focus();
  }

  validate() {
    if (!this.value('front-1').trim()) {
      this.showError('Enter the engraving text first', this.field['front-1']);
      return false;
    }
    if (this.bothSides && !this.sameText && !this.value('back-1').trim()) {
      this.showError('Enter the text for the back, or choose the same text on both sides', this.field['back-1']);
      return false;
    }
    const keys = Object.keys(this.field).filter((key) => this.field[key]);
    const bad = keys.find((key) => !CHARM_ALLOWED.test(this.field[key].value));
    if (bad) {
      this.showError('Use letters, numbers, spaces and . , / & - only', this.field[bad]);
      return false;
    }
    return true;
  }

  onSubmit(event) {
    if (event.target !== this.form || !this.toggle.checked) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (!this.validate()) return;
    this.addToCart();
  }

  buildItems() {
    const data = new FormData(this.form);
    const quantity = parseInt(data.get('quantity'), 10) || 1;
    const shape = this.shape;
    const both = this.bothSides;
    const front = [this.value('front-1').trim(), this.value('front-2').trim()];
    const back = this.backValues().map((v) => v.trim());

    const join = (pair) => (pair[1] ? pair[0] + ' / ' + pair[1] : pair[0]);

    const parentProperties = {};
    data.forEach((value, key) => {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && String(value).trim()) parentProperties[match[1]] = value;
    });
    parentProperties['Engraved charm'] =
      shape.dataset.name + ' \u2014 ' + join(front) + (both ? ' / back: ' + join(back) : '');

    const parent = { id: Number(data.get('id')), quantity, properties: parentProperties };
    if (data.get('selling_plan')) parent.selling_plan = Number(data.get('selling_plan'));

    const charmProperties = {
      'Charm shape': shape.dataset.name + ' (' + shape.dataset.dims + ')',
      _engraved_for: document.title,
    };

    if (both) {
      charmProperties['Front — line 1'] = front[0];
      if (front[1]) charmProperties['Front — line 2'] = front[1];
      charmProperties['Back — line 1'] = back[0];
      if (back[1]) charmProperties['Back — line 2'] = back[1];
      if (this.sameText) charmProperties['Back'] = 'Same as front';
    } else {
      charmProperties['Line 1'] = front[0];
      if (front[1]) charmProperties['Line 2'] = front[1];
    }

    const variantId = both ? shape.dataset.both : shape.dataset.one;

    return [parent, { id: Number(variantId), quantity, properties: charmProperties }];
  }

  setLoading(state) {
    if (!this.submitButton) return;
    this.submitButton.classList.toggle('loading', state);
    this.submitButton.setAttribute('aria-disabled', state);
    const spinner = this.submitButton.querySelector('.loading__spinner, .loading-overlay__spinner');
    if (spinner) spinner.classList.toggle('hidden', !state);
  }

  addToCart() {
    const body = { items: this.buildItems() };
    if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
      body.sections = this.cart.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
    }

    this.setLoading(true);

    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body),
    })
      .then((response) => response.json().then((data) => ({ ok: response.ok, data: data })))
      .then((result) => {
        if (!result.ok || result.data.status) {
          console.error('[charm] cart rejected', result.data);
          this.showCartError(result.data.description || result.data.message || 'Could not add to cart.');
          return;
        }
        try {
          if (!this.cart) throw new Error('no cart element');
          this.cart.classList.remove('is-empty');
          if (typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(document.activeElement);
          }
          this.cart.renderContents(result.data);
        } catch (renderError) {
          console.warn('[charm] added but render failed, reloading', renderError);
          window.location.reload();
        }
      })
      .catch((error) => {
        console.error('[charm] request failed', error);
        this.showCartError('Could not reach the cart. Please try again.');
      })
      .finally(() => this.setLoading(false));
  }

  showCartError(message) {
    if (this.errorWrapper) {
      this.errorWrapper.removeAttribute('hidden');
      const target = this.errorWrapper.querySelector('.product-form__error-message') || this.errorWrapper;
      target.textContent = message;
    } else {
      this.showError(message);
    }
  }
}

if (!customElements.get('charm-engraving')) {
  customElements.define('charm-engraving', CharmEngraving);
}
